class geoMap {
  constructor() {
    this.mapFilter();
    this.mapRegionEvent();
    this.resetMapEvent();
    //this.resizeEvent();
  }

  mapRegionEvent() {
    //console.log(document.querySelector('#mapID').value);
    // replace with your map ID.

    let mapID = document.querySelector('#mapID').value;
    let mapContainer = document.getElementById('map_' + mapID);
    mapContainer.addEventListener('mapready', function (ev) {
      var homeClick = document.querySelectorAll(
        '.imapsZoomControl-group .imapsSprite-group'
      );

      for (const hc of homeClick) {
        hc.addEventListener('click', function () {
          // console.log('fasdfasdf');
          document.querySelector('#stateInfo').classList.add('d-none');
        });
      }
      var mapClicked = document.querySelectorAll('.mapclicked');
      for (const py of mapClicked) {
        py.addEventListener('click', function (e) {
          //console.log("finally i am clicked");
          e.preventDefault();
          var elem = $(e.currentTarget),
            state = elem.attr('id'),
            stateName = elem.attr('data-stateName');
          let data = {
            state: state,
            stateName: stateName,
            action: 'stateContent',
          };
          $.ajax({
            url: foodcorps_object.ajaxurl,
            data: data,
            type: 'POST',
            success: (response) => {
              // console.log(response);
              if (response != '') {
                $('#stateInfo').removeClass('d-none');
                $('#stateInfo').empty();
                $('#stateInfo').append(response);
              }
            },
          });
        });
      }
    });
  }

  mapFilter() {
    $(document).on('click', '.filter-click', (e) => {
      var mainID = $('.igm-live-filter').attr('data-base-map-id');
      var elem = $(e.currentTarget),
        currentID = elem.attr('data-mapid');

      $('.filter-click').removeClass('active');
      elem.addClass('active');
      iMapsManager.filteredMap = currentID;
      if (typeof iMapsManager !== 'undefined') {
        if (mainID == currentID) {
          iMapsManager.filteredMap = false;
          iMapsManager.showAllSeries(currentID);
        } else {
          iMapsManager.hideAllSeries(mainID, true);
          var thisSeries = iMaps.maps[mainID].seriesById[currentID];
          if (thisSeries && thisSeries.length > 0) {
            for (var ix = 0; ix < thisSeries.length; ix++) {
              var serie = thisSeries[ix];
              serie.show();
            }
          }
        }
      }
    });
  }

  resizeEvent() {
    // Add a resize event listener
    window.addEventListener('resize', function () {
      // Get the current window width
      var windowWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;

      // Check if the window width is less than 1024 pixels
      if (windowWidth < 1024) {
        window.location.href = '/map-test/';
        document.querySelector('#stateInfo').classList.add('d-none');
        // var homeClick = document.querySelectorAll('.imapsZoomControl-group .imapsSprite-group');

        // for (const hc of homeClick) {
        //     hc.addEventListener('click', function(){
        //         document.querySelector('#stateInfo').classList.add('d-none');
        //     });
        // }
      }
    });
  }

  resetMapEvent() {
    $(document).on('click', '.map-reset', () => {
      var id = document.getElementById('mapID').value;
      var im = iMapsManager,
        map = im.maps[id].map;
      map.goHome();
      $('#stateInfo').addClass('d-none');
      // in case drillDown is enabled, we hide everything else
      iMapsManager.resetDrilldown(id);
      // reset actions
      if (
        typeof iMapsActions !== 'undefined' &&
        typeof iMapsActions.resetActions !== 'undefined'
      ) {
        iMapsActions.resetActions(id);
      }
    });
  }
}

export default geoMap;
new geoMap();
